<!-- @veltra/icons generated sha256:b9a6a36a5df8ffc4 gen:8 source:src/svg/normal/caret-left.svg -->
<script setup lang="ts">
defineOptions({ name: 'CaretLeft' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M11.35 1.48 4.19 7.65c-.2.18-.2.52 0 .7l7.16 6.17c.27.23.66.02.66-.35V1.83c0-.37-.39-.58-.66-.35"
    />
  </svg>
</template>
